import { render } from "preact";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BuyAgainWidget } from "../components/BuyAgainWidget";
import { PortalProvider } from "../context/PortalContext";
import styles from "../index.css?inline";
import "../index.css";

const WIDGET_HOST_ID = "social-ocean-buy-again-host";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function mountBuyAgainWidget(container: HTMLElement) {
  if (document.getElementById(WIDGET_HOST_ID)) {
    return;
  }

  const host = document.createElement("div");
  host.id = WIDGET_HOST_ID;

  host.style.position = "fixed";
  host.style.top = "0";
  host.style.left = "0";
  host.style.width = "0";
  host.style.height = "0";
  host.style.zIndex = "99";

  container.appendChild(host);

  const shadow = host.attachShadow({ mode: "open" });

  const rootWrapper = document.createElement("div");
  rootWrapper.className = "so-widget-root";
  rootWrapper.style.isolation = "isolate";
  shadow.appendChild(rootWrapper);

  try {
    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [styleSheet];
  } catch (e) {
    console.error(
      "Failed to construct CSSStyleSheet, falling back to <style>",
      e
    );
    const style = document.createElement("style");
    style.textContent = styles;
    shadow.appendChild(style);
  }

  render(
    <QueryClientProvider client={queryClient}>
      <PortalProvider container={rootWrapper}>
        <BuyAgainWidget />
      </PortalProvider>
    </QueryClientProvider>,
    rootWrapper
  );
}

if (typeof window !== "undefined") {
  const init = () => {
    if (!document.getElementById(WIDGET_HOST_ID)) {
      mountBuyAgainWidget(document.body);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
}
